import { TagManager } from "@dealer-center/core-third-party-gtm";
import styled from "styled-components";
import type { ButtonInterface } from "../button";
import { Button } from "../button";

export const StyledSubmitButton = styled.div`
  // this is a temporary fix for the button being wrapped in a div
  display: inline-block;
  & > div {
    display: inherit;
  }
`;
export const SubmitButton = ({
  onClick,
  analyticsConfiguration,
  ...props
}: ButtonInterface) => {
  return (
    <StyledSubmitButton>
      <Button
        analyticsConfiguration={analyticsConfiguration}
        {...props}
        onClick={interstateEvent => {
          if (analyticsConfiguration) {
            TagManager.event({
              eventName: analyticsConfiguration.eventName,
              eventProperties: analyticsConfiguration.eventProperties
            });
          }
          if (onClick) {
            onClick(interstateEvent);
          }
        }}
      />
    </StyledSubmitButton>
  );
};
